// CaptchaComponent.js
import React, { useState, useEffect, forwardRef } from 'react';

const CaptchaComponent = forwardRef(({ onCaptchaChange }, ref) => {
    const [captcha, setCaptcha] = useState('');
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        generateCaptcha();
    }, []);

    const generateCaptcha = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let captchaText = '';
        for (let i = 0; i < 6; i++) {
            captchaText += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        setCaptcha(captchaText);
        setInputValue(''); // Clear the input value when generating a new captcha
        onCaptchaChange(captchaText, ''); // Pass the new captcha value to the parent
    };

    const handleInputChange = (event) => {
        const value = event.target.value;
        setInputValue(value);
        onCaptchaChange(captcha, value); // Pass both captcha and the entered value to parent
    };

    return (
        <div className='row'>
            <div className='col-sm-6 d-flex'>
                <div className='lblcaptcha'>{captcha}</div>
                <span className="btn_refresh" onClick={generateCaptcha}><i className="bi bi-arrow-clockwise"></i></span>
            </div>
            <div className='col-sm-6'>
                <input
                    type="text"
                    className='txt1'
                    placeholder="Enter CAPTCHA"
                    value={inputValue}
                    onChange={handleInputChange}
                    tabIndex={6}
                    ref={ref} // Forward the ref to the input element
                />
            </div>
        </div>
    );
});

export default CaptchaComponent;
